<template>
  <div class="container">
    <heard :title="'老年多模态多媒体语料库切分标注平台--MMSE'" />
    <div class="content" id="content">
      <div class="row">
        <div style="width: 100px">医生姓名：</div>
        <el-input
          v-model="datas.doctorName"
          placeholder="请输入内容"
          style="width: 300px"
        ></el-input>
      </div>
      <div class="row">
        <div style="width: 100px">项目名称：</div>
        <el-input
          v-model="datas.projectName"
          placeholder="请输入内容"
          style="width: 300px"
        ></el-input>
      </div>
      <div class="row">
        <div style="width: 100px">项目LOGO：</div>
        <div v-if="datas.logo" class="imgWrap">
          <img :src="datas.logo" />
          <el-upload
            :change="uploadChange('logo')"
            :accept="accept.join(',')"
            class="avatar-uploader"
            action="#"
            :http-request="uploadLogo"
            :show-file-list="false"
          >
            <el-link type="primary" style="margin-left: 15px">修改图片</el-link>
          </el-upload>
        </div>
        <el-upload
          v-else
          :change="uploadChange('logo')"
          :accept="accept.join(',')"
          class="avatar-uploader"
          action="#"
          :http-request="uploadLogo"
          :show-file-list="false"
        >
          <el-link type="primary">上传图片</el-link>
        </el-upload>
      </div>
      <div class="row">
        <div style="width: 100px">合作单位1：</div>
        <el-input
          v-model="datas.ad1Name"
          placeholder="请输入内容"
          style="width: 300px"
        ></el-input>
      </div>
      <div class="row">
        <div style="width: 100px">单位1地址：</div>
        <el-input
          v-model="datas.ad1Url"
          placeholder="请输入内容"
          style="width: 300px"
        ></el-input>
      </div>
      <div class="row">
        <div style="width: 100px">LOGO：</div>
        <div v-if="datas.ad1Url1" class="imgWrap">
          <img :src="datas.ad1Url1" />
          <el-upload
            :change="uploadChange('ad1Url1')"
            :accept="accept.join(',')"
            class="avatar-uploader"
            action="#"
            :http-request="uploadLogo"
            :show-file-list="false"
          >
            <el-link type="primary" style="margin-left: 15px">修改图片</el-link>
          </el-upload>
        </div>
        <el-upload
          v-else
          :accept="accept.join(',')"
          class="avatar-uploader"
          action="#"
          :change="uploadChange('ad1Url1')"
          :http-request="uploadLogo"
          :show-file-list="false"
        >
          <el-link type="primary">上传图片</el-link>
        </el-upload>
      </div>
      <div class="row">
        <div style="width: 100px">合作单位2：</div>
        <el-input
          v-model="datas.ad2Name"
          placeholder="请输入内容"
          style="width: 300px"
        ></el-input>
      </div>
      <div class="row">
        <div style="width: 100px">单位2地址：</div>
        <el-input
          v-model="datas.ad1Url"
          placeholder="请输入内容"
          style="width: 300px"
        ></el-input>
      </div>
      <div class="row">
        <div style="width: 100px">LOGO：</div>
        <!-- <img :src="datas.ad1Url2" v-if="datas.ad1Url2" /> -->
        <div v-if="datas.ad1Url2" class="imgWrap">
          <img :src="datas.ad1Url2" />
          <el-upload
            :change="uploadChange('ad1Url2')"
            :accept="accept.join(',')"
            class="avatar-uploader"
            action="#"
            :http-request="uploadLogo"
            :show-file-list="false"
          >
            <el-link type="primary" style="margin-left: 15px">修改图片</el-link>
          </el-upload>
        </div>
        <el-upload
          v-else
          :accept="accept.join(',')"
          class="avatar-uploader"
          action="#"
          :change="uploadChange('ad1Url2')"
          :http-request="uploadLogo"
          :show-file-list="false"
        >
          <el-link type="primary">上传图片</el-link>
        </el-upload>
      </div>
      <div class="row">
        <el-button  style="width:190px;margin-right:15px" @click="$router.go(-1)">取消</el-button>
        <el-button type="primary" style="width:190px">保存</el-button>
      </div>
    </div>
    <foot :show="true" ref="foot" />
  </div>
</template>

<script>
import user from "../components/portrait.vue";
import heard from "../components/heard.vue";
import foot from "../components/footer.vue";
import { uploadImages } from "../utils/mmse";
import { mapState } from "vuex";
export default {
  name: "VueMmse",
  data: () => {
    return {
      accept: [".jpg", ".png"],
      input: "",
      currentType: "",
      datas: {
        doctorName:'',
        projectName:'',
        ad1Name:'',
        ad1Url:'',
        ad2Name:'',
        ad2Url:'',
        logo: "https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg",
        
        ad1Url1:
          "https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg",
        ad1Url2:
          "https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg",
      },
    };
  },
  computed:{
    ...mapState(['userInfo'])
  },
  mounted(){
    if(!this.userInfo.doctorName){
        this.$router.push({name:'index'})
        return
    }
    this.datas.doctorName = this.userInfo.doctorName
  },
  methods: {
    uploadChange(e) {
      this.currentType = e;
    },
    uploadLogo(file) {
      let params = new FormData();
      params.append("file", file.file);
      uploadImages(params).then((res) => {
        this.datas[this.currentType] = res.data;
      });
    },
  },
  components: {
    heard,
    foot,
    user,
  },
};
</script>
<style lang="less" scoped>
.container {
  width: 100%;
  .content {
    height: calc(100vh - 160px);
    overflow-y: scroll;
    padding: 30px;
    .row {
      display: flex;
      align-items: center;
      margin-bottom: 25px;
      .imgWrap {
        display: flex;
        align-items: center;
      }
      img {
        width: 300px;
        height: 200px;
      }
    }
  }
}
</style>
